import React from 'react';
import './DetailBox.css'; 

const LargeDetailBox = ({ label, value }) => {
  return (
    <div className='large-detail-box'>
      <label className='detail-box-label fts-12 lt-gray'>{label}</label>
      <input type="text" className='large-detail-input fts-15' value={value} readOnly />
    </div>
  );
};

export default LargeDetailBox;
